import { useCallback } from 'react';
import { newAlertModal } from 'Views/Components/Modal/NewAlertModal';
import { useAnytimeTicketStore, useAnytimeTicketStoreApi } from '../State/AnytimeTicketContext';

export default function useAnytimeTicketSession() {
	const abortPurchase = useAnytimeTicketStore(s => s.abortPurchase);

	const handleTimerExpiry = useCallback(() => {
		abortPurchase();
		newAlertModal('Session has expired', 'You ran out of time. Please start a new product purchase.', {
			cancelText: 'OK',
			shouldCloseOnOverlayClick: false,
			shouldCloseOnEsc: false,
		});
	}, [abortPurchase]);

	return { handleTimerExpiry };
}
